module.exports = __webpack_public_path__ + "static/media/fk.4973e028.svg";